import { apiClient } from '@/app/core/services/apiClient.service';
import { BaseApiService } from '@/app/shared/services/apis/baseApi.service';

class TranslationsApiService extends BaseApiService {
    getOverrides(params) {
        return this.client.get(`translation-overrides`, params);
    }
    getFrontendOverrides(params) {
        return this.client.get(`translation-overrides/frontend`, params);
    }
    updateOverrides(payload) {
        return this.client.post(`translation-overrides`, payload);
    }
    deleteOverride(translationOverrideId, payload) {
        return this.client.delete(`translation-overrides/${translationOverrideId}`, payload);
    }
}
export const translationsApi = new TranslationsApiService(apiClient);
